import { EmbedSyncedDocBlockSchema } from '@blocksuite/hive-model';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { EmbedSyncedDocBlockAdapterExtensions } from './adapters/extension';
import { createBuiltinToolbarConfigExtension } from './configs/toolbar';

const flavour = EmbedSyncedDocBlockSchema.model.flavour;

export const EmbedSyncedDocBlockSpec: ExtensionType[] = [
  FlavourExtension(flavour),
  BlockViewExtension(flavour, model => {
    return model.parent?.flavour === 'hive:surface'
      ? literal`hive-embed-edgeless-synced-doc-block`
      : literal`hive-embed-synced-doc-block`;
  }),
  EmbedSyncedDocBlockAdapterExtensions,
  createBuiltinToolbarConfigExtension(flavour),
].flat();
